lmApp
  .service('VirtualLiveApiService', ['$q', '$http', function ($q, $http) {
    var service = {};

    var endpoint = '/discovery:80/vlive';

    service.SetToken = function (token) {
      service.token = token;
      //$http.defaults.headers.common['X-Supervisor-Token'] = token;
    };

    var JSONRequest = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    var PlainRequest = {
      headers: {
        'Content-Type': 'text/plain'
      }
    };

    service.GetPlaylist = function (asset_id) {
      var deferred = $q.defer();

      lh.common.request.get('/vlive/playlists/' + asset_id)
        .then(function (response) {
          deferred.resolve(response.playlist);

        }, function (reason) {
          reason.url = '/vlive/playlists/' + asset_id;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.SetPlaylist = function (asset_id, playlist) {
      var deferred = $q.defer();

      var request = JSONRequest;

      request.url = endpoint + '/playlists/'+ asset_id + '/groups';
      request.data = (playlist || []).map(function (item) {
        var data;

        data = {
          type: item.type,
          items: item.items.map(function (item) {
            return {
              id: item.id,
              ads: item.ads
            }
          })
        };

        if (item.name) data.name = item.name;
        if (item.description) data.description = item.description;
        if (item.poster) data.poster = item.poster;

        return data;
      });

      request.headers['X-Auth-Token'] = lh.common.config.get('authToken');

      request.method = 'PUT';

      $http(request)
        .then(function (response) {
          var answer = response.data;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          if (answer.result) {
            deferred.resolve(answer);
          } else {
            answer.data = request.data;
            answer.url = endpoint + '/v1/playlists/'+ asset_id + '/groups';
            deferred.reject(answer.error);
          }
        }, function (response) {
          var data = response.answer;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          deferred.reject(data);
        });

      return deferred.promise;
    };

    service.SetStartTime = function (asset_id, startTime) {
      var deferred = $q.defer();

      var request = PlainRequest;

      request.url = endpoint + '/playlists/'+ asset_id + '/start-time';
      request.data = startTime || moment.utc();

      request.headers['X-Auth-Token'] = lh.common.config.get('authToken');

      request.method = 'PUT';

      $http(request)
        .then(function (response) {
          var answer = response.data;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          if (answer.result) {
            deferred.resolve(answer);
          } else {
            answer.data = request.data;
            answer.url = endpoint + '/playlists/'+ asset_id + '/start-time';
            deferred.reject(answer.error);
          }
        }, function (response) {
          var data = response.answer;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          deferred.reject(data);
        });

      return deferred.promise;
    };

    service.Request = function (url, method, data) {
      var deferred = $q.defer();

      if (!url) {
        deferred.reject({
          result: 0,
          message: 'No URL found'
        });
        return;
      }

      request.url = endpoint + url;
      request.data = data;
      request.headers['X-Supervisor-Token'] = service.token;

      if (method) {
        request.method = method;
      } else {
        request.method = 'GET';
      }

      $http(request)
        .then(function (response) {
          var answer = response.data;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          if (answer.result) {
            deferred.resolve(answer);
          } else {
            answer.data = data;
            answer.url = url;
            deferred.reject(answer.error);
          }
        }, function (response) {
          var data = response.answer;
          var status = response.status;
          var headers = response.headers;
          var config = response.config;

          console.log(data, status, headers, config);
          deferred.reject(data);
      });

      return deferred.promise;
    };

    return service;
  }]);
